/**
 * Custom error class for Elasticsearch access/permission issues.
 * Thrown when a user lacks the required token or receives a 401/403 from Elasticsearch.
 */
export class ElasticsearchAccessError extends Error {
  constructor(message = "Insufficient permissions to access Elasticsearch") {
    super(message);
    this.name = "ElasticsearchAccessError";
  }
}
